
export default {
  header: {
    self: {},
    items: [
      {
        title: "Dashboards",
        root: true,
        icon: "flaticon2-architecture-and-city",
        alignment: "left",
        page: "dashboard",
        translate: "MENU.DASHBOARD",
        permission: 'main-dashboard'
      },
      {
        title: "ITSM",
        alignment: "left",
        // bullet: "line",
        toggle: "click",
        root: true,
        icon: "flaticon2-rocket",
        page: "itsm/tickets",
        permission: 'itsm'
      },
      {
        title: "Tools",
        root: true,
        alignment: "left",
        toggle: "click",
        icon: "flaticon2-tools-and-utensils",
        permission: 'tools',
        submenu: [
          {
            title: "Links",
            alignment: "right",
            root: true,
            toggle: "click",
            icon: "flaticon2-folder",
            permission: 'tools-links',
            submenu: [
              {
                title: "Firewall",
                alignment: "right",
                root: true,
                toggle: "click",
                icon: "flaticon2-folder",
                permission: 'tools-links-firewall',
                submenu: []
              }
            ]
          },
          {
            title: "Visual Policy Lookup",
            bullet: "dot",
            page: "tools/visualpolicylookup",
            permission: 'tools-visual-policy-lookup',
          },
          {
            title: "Network Topology",
            bullet: "dot",
            page: "tools/networktopology",
            permission: 'tools-network-topology',
          },
        ]
      }
    ]
  },
  aside: {
    self: {},
    items: [
      {
        title: "Dashboard",
        root: true,
        icon: "flaticon2-architecture-and-city",
        page: "dashboard",
        translate: "MENU.DASHBOARD",
        bullet: "dot",
        permission: 'main-dashboard'
      },
      {
        title: "ITSM",
        bullet: "line",
        icon: "flaticon2-rocket",
        page: "itsm/tickets",
        permission: 'itsm'
      },
      {
        title: "Automation",
        root: true,
        alignment: "left",
        bullet: "line",
        //toggle: "click",
        page: "itsm/tickets",
        icon: "flaticon2-heart-rate-monitor",
        permission: 'automation'
      },
      { section: "Tools" },
      {
        title: "Tools",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'tools',
        icon: "flaticon2-tools-and-utensils",
        submenu: [
          {
            title: "Visual Policy Lookup",
            bullet: "dot",
            page: "tools/visualpolicylookup",
            permission: 'tools-visual-policy-lookup',
          },
          {
            title: "Network Topology",
            bullet: "dot",
            page: "tools/networktopology",
            permission: 'tools-network-topology',
          },
        ]
      },
      { separator: 'System', permission: 'main-dashboard' },
      { section: "Admin" },
      {
        title: "Admin",
        root: true,
        alignment: "left",
        toggle: "click",
        permission: 'admin',
        icon: "flaticon2-settings",
        submenu: [
          {
            title: "Users",
            bullet: "dot",
            page: "admin/users",
            permission: 'admin-users',
          },
          {
            title: "Roles",
            bullet: "dot",
            page: "admin/roles",
            permission: 'admin-roles',
          },
          {
            title: "Permissions",
            bullet: "dot",
            page: "admin/permissions",
            permission: 'admin-permissions',
          },
          {
            title: "Settings",
            bullet: "dot",
            page: "admin/config",
            permission: 'admin-settings',
          },
          {
            title: "Templates",
            bullet: "dot",
            page: "admin/templates",
            permission: 'admin-templates',
          },
          {
            title: "Template Categories",
            bullet: "dot",
            page: "admin/templatecategories",
            permission: 'admin-template-categories',
          },
          {
            title: "Kanban Boards",
            bullet: "dot",
            page: "admin/kanbanboards",
            permission: 'admin-kanban-boards',
          },
          {
            title: "Budget",
            bullet: "dot",
            page: "admin/budgets",
            permission: 'admin-budget'
          },
          {
            title: "API Requests",
            bullet: "dot",
            page: "admin/apirequests",
            permission: 'admin-api-audit-view_requests',
          },
        ]
      },

    ]
  }
};
